import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useAuthStore = defineStore('security', () => {
  const user = ref(null);
  const loading = ref(false);
  const isLoaded = ref(false);
  const isAuthenticated = computed(() => user.value !== null);

  return { user, isAuthenticated, loading, isLoaded };
});
